import React from "react";

const OTASettings = () => {
  return <div>Settings</div>;
};

export default OTASettings;
